module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAS0lEQVR42u3TUQoAIAgD0K2LRydfB4h0YT9B+xR8qCAloZqGC3kAIdmdWjrJrul4HQeybpJB9mEjyEYkjRISARaSASniAADA/4BLJotfFx9/E+bbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-last.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-last.png
// module chunks = styles